import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-document-analysis-composition-bar',
  templateUrl: './document-analysis-composition-bar.component.html',
  styleUrls: ['./document-analysis-composition-bar.component.scss'],
  standalone: false,
})
export class DocumentAnalysisCompositionBarComponent {
  @Input() pending: number = 0;
  @Input() approved: number = 0;
  @Input() rejected: number = 0;
  /** Altura da barra. `4px` na tabela e no card, `6px` no hero. */
  @Input() height: string = '4px';

  get total(): number {
    return this.pending + this.approved + this.rejected;
  }

  get tooltip(): string {
    return `${this.pending} pendentes · ${this.approved} aprovados · ${this.rejected} rejeitados`;
  }

  percent(value: number): number {
    return this.total > 0 ? (value / this.total) * 100 : 0;
  }
}
